module.exports = __webpack_public_path__ + "img/ИФ-1(А)-016.9dba0be4.png";